import { render } from "./RatingStars.vue?vue&type=template&id=08541474"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__